// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   allData: false,
//   accessKey: localStorage.getItem("accessKey") === "true" ? true : false,
//   getUserState: "",
//   getUserName: "",
// };

// const dataSlice = createSlice({
//   name: "data",
//   initialState,
//   reducers: {
//     toggleData: (state, action) => {
//       state.allData = action.payload;
//     },
//     adminAccessKey: (state, action) => {
//       state.accessKey = action.payload;
//       // Save the accessKey to localStorage whenever it changes
//       localStorage.setItem("accessKey", action.payload);
//     },
//     storeState: (state, action) => {
//       state.getUserState = action.payload;
//     },
//     storeName: (state, action) => {
//       state.getUserName = action.payload;
//     },
//   },
// });

// export const { toggleData, adminAccessKey, storeState, storeName } = dataSlice.actions;

// export default dataSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allData: false,
  accessKey: localStorage.getItem("accessKey") === "true",
  getUserState: "",
  getUserName: "",
  activeChats: {},
};

const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    toggleData: (state, action) => {
      state.allData = action.payload;
    },
    adminAccessKey: (state, action) => {
      state.accessKey = action.payload;
      localStorage.setItem("accessKey", action.payload);
    },
    storeState: (state, action) => {
      state.getUserState = action.payload;
    },
    setUserName: (state, action) => {
      state.getUserName = action.payload;
    },
    addChatWindow: (state, action) => {
      const { userId, username } = action.payload;
      state.activeChats[userId] = { username, isMinimized: false };
    },
    removeChatWindow: (state, action) => {
      delete state.activeChats[action.payload];
    },
    toggleMinimizeChat: (state, action) => {
      const userId = action.payload;
      if (state.activeChats[userId]) {
        state.activeChats[userId].isMinimized = !state.activeChats[userId].isMinimized;
      }
    },
  },
});

export const {
  toggleData,
  adminAccessKey,
  storeState,
  setUserName,
  addChatWindow,
  removeChatWindow,
  toggleMinimizeChat,
} = dataSlice.actions;

export default dataSlice.reducer;
